import { useQuery } from "@tanstack/react-query";
import { getModerationItem } from "@/services/adminApi";

export function useModerationItem(experienceId: string | null) {
  return useQuery({
    queryKey: ["admin", "moderation", "item", experienceId],
    queryFn: () => getModerationItem(experienceId!),
    enabled: !!experienceId,
  });
}
